import * as Yup from 'yup';

export const GOOGLE_AUTOCOMPLETE_LIBRARIES = ['places'];
export const GOOGLE_AUTOCOMPLETE_AND_MAPS_LIBRARIES = ['places', 'geometry'];
export const SENSITIVE_DATA_FIELDS = ['ssn', 'dob', 'dlNumber'];

export const STRIPE_CREDIT_CARD_FEE_PERCENT = 1 / (1 - 0.029) - 1;
export const STRIPE_TRANSACTION_FEE_AMOUNT = 0.3;
export const STRIPE_PAYOUT_FEE_PERCENT = 0.0025;

/* DEVELOPMENT/STAGING OEM CONSTS */
export const BP_OEM_KEY = 'bp-test-oem';
export const BP_OEM_ID = 'bp-test-oem-id';
export const BACKEND_BP_OEM_KEY = 'backend-bp-test-oem';
export const BACKEND_BP_OEM_ID = 'backend-bp-test-oem-id';
export const CHECKOUT_OEM_KEY = 'checkout-test-oem';
export const CHECKOUT_OEM_ID = 'checkout-test-oem-id';
export const DEV_OEM_KEY = 'dev-project-key';
export const DEV_BRAND_KEY = 'dev-brand-key';
export const DEV_OEM_ID = 'dev-oem-id';
export const DEMO_BRAND_KEY = 'demo-brand-key';
export const DEMO_OEM_ID = 'demo-oem-id';
/* END DEVELOPMENT/STAGING OEM CONSTS */

/* PROD OEM CONSTS */
export const JANUS_OEM_KEY = 'janus';
export const JANUS_OEM_ID = 'QczG5nHitwkBiiQBFiLW';
export const MOKE_OEM_KEY = 'moke';
export const MOKE_OEM_ID = '4FhrbkWLHYkGnLjsxh7S';
export const LAND_OEM_KEY = 'land';
export const LAND_OEM_ID = 'Dw11Hij5QzzTenm6Odbf';
export const PICKMAN_OEM_KEY = 'pickman';
export const PICKMAN_OEM_ID = 'GJBxwpJIcckYRUj2FRBE';
export const MAEVING_OEM_KEY = 'maeving';
export const MAEVING_OEM_ID = 'QZzao3tGSmDzt94SfAWG';
export const STARK_OEM_KEY = 'stark';
export const STARK_OEM_ID = 'Ju81l5hQ84wFV9M4qz5b';
export const POWERPLUS_OEM_KEY = 'powerplus';
export const POWERPLUS_OEM_ID = 'AACt7ZVbJOj72VLIImVp';
export const INFINITE_MACHINE_OEM_KEY = 'infinitemachine';
export const INFINITE_MACHINE_OEM_ID = 'Vmh8UEJmHNSp3y8V6Iah';
export const NAXEON_OEM_KEY = 'naxeon';
export const NAXEON_OEM_ID = 'PopnkzSwozYYHEVTgYji';
export const PINNED_OEM_KEY = 'pinnedelectric';
export const BAKCOU_OEM_KEY = 'bakcou';
export const BAKCOU_OEM_ID = 'VKECfSSBPRfgAhCf1Xtx';
export const NIU_OEM_KEY = 'niu';
export const NIU_OEM_ID = 'vRDPTlx0iYpapCrcVzYH';
export const ZERO_OEM_KEY = 'zero';
export const ZERO_OEM_ID = 'HtkZJuOQNvJcce1n7zJo';
export const DUST_OEM_KEY = 'dust';
export const DUST_OEM_ID = '18gXllTJbLOJwdffMOsb';
export const PAVE_OEM_KEY = 'pave';
export const PAVE_OEM_ID = 'zJ5qYxnHWHyreIV2nSI1';
export const LIVEWIRE_OEM_KEY = 'livewire';
export const LIVEWIRE_OEM_ID = 'x81l2N5CvgQjINb2MCbU';
export const MASSIMO_OEM_KEY = 'massimo';
export const MASSIMO_OEM_ID = 'SrwoTk9EU1H0KAaPFJBJ';
export const BONNELL_OEM_KEY = 'bonnell';
export const BONNELL_OEM_ID = 'Jw8udgBsAXMjrjLML49Y';
export const CCW_OEM_KEY = 'ccw';
export const CCW_OEM_ID = 'raCp4HgGXVEAOEfL1bDu';
export const RENA_OEM_KEY = 'rena';
export const RENA_OEM_ID = 'wmqi57D0VejCIfg6QGEA';
// BRANDS
export const ARCTIC_LEOPARD_BRAND_KEY = 'arcticleopard';
export const ARCTIC_LEOPARD_OEM_ID = 'VMkxU71XsTQEuNZrEppm';
export const VENTUS_BRAND_KEY = 'ventus';
export const VENTUS_OEM_ID = 'Drso8RcbqUuG6vHBbCUT';
export const BAKCOU_BRAND_KEY = 'bakcou';
export const NIU_BRAND_KEY = 'niu';
export const ZERO_BRAND_KEY = 'zero';
export const DUST_BRAND_KEY = 'dust';
export const PAVE_BRAND_KEY = 'pave';
export const LIVEWIRE_BRAND_KEY = 'livewire';
export const MASSIMO_BRAND_KEY = 'massimo';
export const BONNELL_BRAND_KEY = 'bonnell';
export const CCW_BRAND_KEY = 'ccw';
export const RENA_BRAND_KEY = 'rena';
/* END PROD OEM CONSTS */

export const INPUT_TYPES = {
	TEXT_INPUT: 'INPUT',
	SELECT: 'SELECT',
	CHECK: 'CHECK',
	CHECK_SELECT: 'CHECK_SELECT',
	DATE: 'DATE',
	ADDRESS: 'ADDRESS',
	TITLE_DIVIDER: 'TITLE_DIVIDER',
	TEXT_AREA: 'TEXT_AREA',
};

// Map from oemKey to firebase database project id
export const OEM_KEY_TO_PROJECT_MAP = {
	e2etestoem: 'e2etestoem-prod',
	janus: 'janus-prod-a3c47',
	moke: 'moke-3b4f5',
	land: 'land-prod-ddbc9',
	pickman: 'pickman-prod',
	maeving: 'maeving-prod',
	stark: 'stark-prod-631be',
	powerplus: 'powerplus-prod',
	naxeon: 'naxeon-prod',
	infinitemachine: 'infinitemachine-prod',
	[DEV_OEM_KEY]: 'airdealer-67669',
	pinnedelectric: 'pinned-prod',
	bakcou: 'bakcou-prod',
	niu: 'niu-prod-2e9d3',
	zero: 'zero-prod-8f2dc',
	dust: 'dust-prod-cfcf6',
	pave: 'pave-prod',
	livewire: 'livewire-prod',
	massimo: 'massimo-prod',
	bonnell: 'bonnell-prod',
	ccw: 'ccw-prod-04222025',
	rena: 'airdealer-67669', // change to prod once prod clients deployed
};

export const oemMap = {
	[CHECKOUT_OEM_KEY]: CHECKOUT_OEM_ID,
	[BP_OEM_KEY]: BP_OEM_ID,
	e2etestoem: 'Ju81l5hQ84wFV9M4qz5b',
	[JANUS_OEM_KEY]: JANUS_OEM_ID,
	[MOKE_OEM_KEY]: MOKE_OEM_ID,
	[LAND_OEM_KEY]: LAND_OEM_ID,
	[PICKMAN_OEM_KEY]: PICKMAN_OEM_ID,
	[MAEVING_OEM_KEY]: MAEVING_OEM_ID,
	[STARK_OEM_KEY]: STARK_OEM_ID,
	[POWERPLUS_OEM_KEY]: POWERPLUS_OEM_ID,
	[INFINITE_MACHINE_OEM_KEY]: INFINITE_MACHINE_OEM_ID,
	[NAXEON_OEM_KEY]: NAXEON_OEM_ID,
	[PINNED_OEM_KEY]: {
		[ARCTIC_LEOPARD_BRAND_KEY]: ARCTIC_LEOPARD_OEM_ID,
		[VENTUS_BRAND_KEY]: VENTUS_OEM_ID,
	},
	[BAKCOU_OEM_KEY]: {
		[BAKCOU_BRAND_KEY]: BAKCOU_OEM_ID,
	},
	[NIU_OEM_KEY]: {
		[NIU_BRAND_KEY]: NIU_OEM_ID,
	},
	[ZERO_OEM_KEY]: {
		[ZERO_BRAND_KEY]: ZERO_OEM_ID,
	},
	[DUST_OEM_KEY]: {
		[DUST_BRAND_KEY]: DUST_OEM_ID,
	},
	[PAVE_OEM_KEY]: {
		[PAVE_BRAND_KEY]: PAVE_OEM_ID,
	},
	[LIVEWIRE_OEM_KEY]: {
		[LIVEWIRE_BRAND_KEY]: LIVEWIRE_OEM_ID,
	},
	[MASSIMO_OEM_KEY]: {
		[MASSIMO_BRAND_KEY]: MASSIMO_OEM_ID,
	},
	[BONNELL_OEM_KEY]: {
		[BONNELL_BRAND_KEY]: BONNELL_OEM_ID,
	},
	[CCW_OEM_KEY]: {
		[CCW_BRAND_KEY]: CCW_OEM_ID,
	},
	// DEV and DEMO
	[DEV_OEM_KEY]: {
		[DEV_BRAND_KEY]: DEV_OEM_ID,
		[DEMO_BRAND_KEY]: DEMO_OEM_ID,
	},
	[RENA_OEM_KEY]: {
		[RENA_BRAND_KEY]: RENA_OEM_ID,
	},
};

export const MIN_FIELDS_TO_COLLECT = {
	CARRIER_NAME: 'carrierName',
	POLICY_ID: 'policyId',
	EFFECTIVE_DATE: 'effectiveDate',
	EXPIRY_DATE: 'expiryDate',
	POLICY_NUMBER: 'carrierPolicyNumber',
	AGENT_OR_BROKER_NAME: 'agentBrokerName',
	POLICY_NAME: 'name',
	ISSUING_STATE: 'issuingState',
	POLICY_TYPE: 'policyType',
};

// map to stripe id document types
export const ID_DOCUMENT_TYPE_ENUM = {
	DRIVERS_LICENSE: 'driving_license',
	ID_CARD: 'id_card',
	PASSPORT: 'passport',
};

export const PROMOTION_TYPES = {
	FINANCING: 'FINANCING',
};

export const MAX_WEEKS_BEFORE_READY = 100;

export const FinancingActionItemOptions = {
	WAIT_FOR_SUBMISSION_WINDOW: 'WAIT_FOR_SUBMISSION_WINDOW',
	SUBMIT_CREDIT_APP_AND_REPORT_DECISION: 'SUBMIT_CREDIT_APP_AND_REPORT_DECISION',
	GATHER_ADDITIONAL_INFO: 'GATHER_ADDITIONAL_INFO',
	PERFORM_PREAUDIT: 'PERFORM_PREAUDIT',
	SIGN_DOCS: 'SIGN_DOCS',
	SUBMIT_FUNDING_PACKAGE: 'SUBMIT_FUNDING_PACKAGE',
	WAIT_FOR_FUNDED_NOTICE: 'WAIT_FOR_FUNDED_NOTICE',
	BLOCKED: 'BLOCKED',
	COMPLETE: 'COMPLETE',
};

export const abbrevStateNamesArr = [
	'AL',
	'AK',
	'AS',
	'AZ',
	'AR',
	'CA',
	'CO',
	'CT',
	'DE',
	'DC',
	'FM',
	'FL',
	'GA',
	'GU',
	'HI',
	'ID',
	'IL',
	'IN',
	'IA',
	'KS',
	'KY',
	'LA',
	'ME',
	'MH',
	'MD',
	'MA',
	'MI',
	'MN',
	'MS',
	'MO',
	'MT',
	'NE',
	'NV',
	'NH',
	'NJ',
	'NM',
	'NY',
	'NC',
	'ND',
	'MP',
	'OH',
	'OK',
	'OR',
	'PW',
	'PA',
	'PR',
	'RI',
	'SC',
	'SD',
	'TN',
	'TX',
	'UT',
	'VT',
	'VI',
	'VA',
	'WA',
	'WV',
	'WI',
	'WY',
];

// FOR BELOW FIELDS MAP:

// If type is INPUT_TYPES.CHECK
// - needs fields:
//   - checkLabel
//   - type: INPUT_TYPES.CHECK
//   - label
//   - yup
// 	 - title

// If type is INPUT_TYPES.INPUT
// - needs fields:
//   - inputType (text, date, tel)
//   - type: INPUT_TYPES.INPUT
//   - label
//   - yup
//   - title

// If type is INPUT_TYPES.SELECT
// - needs fields:
//   - list: [
//			{ value: <val_1>, text: <display_text_1> },
//  		{ value: <val_2,  text: <display_text_2> },
//  		...
// 		]
//   - type: INPUT_TYPES.INPUT
//   - label
//   - yup
//   - title

export const ADDITIONAL_FIELDS_MAP = {
	isOwnerResident: {
		type: INPUT_TYPES.CHECK_SELECT,
		checkLabel: 'Are you a resident of the registration state?',
		label: 'Are you a resident of the registration state?',
		yup: Yup.boolean('Required').required('Required'),
		title: 'Residency status',
		defaultValue: true,
	},
	addressIsInUnincorporatedArea: {
		type: INPUT_TYPES.CHECK,
		checkLabel: 'Is your address in an unincorporated area?',
		label: 'Is your address in an unincorporated area?',
		yup: Yup.boolean().required('Required'),
		title: 'Unincorporated area',
		defaultValue: true,
	},
	ssn: {
		type: INPUT_TYPES.TEXT_INPUT,
		inputType: 'text',
		label: 'Social Security Number',
		yup: Yup.string()
			.required('SSN is required')
			.matches(
				/^(\d{3}-?\d{2}-?\d{4}|XXX-XX-XXXX)$/,
				'Please ensure your SSN is in the correct format',
			),
		title: 'Social Security Number',
		mask: '999-99-9999',
	},
	isOwnerSpouseOfMilitary: {
		type: INPUT_TYPES.CHECK,
		checkLabel: 'Are you the spouse of a member of the military?',
		label: 'Spouse to military member',
		yup: Yup.boolean().required('Required'),
		title: 'Owner is spouse to military member',
		defaultValue: true,
	},
	recreationalPassportFee: {
		type: INPUT_TYPES.CHECK,
		checkLabel: 'Do you want to include the Recreational Passport with registration?',
		label: 'Recreational Passport',
		yup: Yup.boolean().required('Required'),
		title: 'Recreational Passport',
		defaultValue: true,
	},
	keepColoradoWildPass: {
		type: INPUT_TYPES.CHECK,
		checkLabel: 'Do you want to include the Keep Colorado Wild Pass with registration?',
		label: 'Keep Colorado Wild Pass',
		yup: Yup.boolean().required('Required'),
		title: 'Keep Colorado Wild Pass',
		defaultValue: true,
	},
	temporarilyLivingOutOfState: {
		type: INPUT_TYPES.CHECK_SELECT,
		checkLabel: 'Are you temporarily living out of state?',
		label: 'Temporarily out of state',
		yup: Yup.boolean('Required').required('Required'),
		title: 'Temporarily out of state',
		defaultValue: true,
	},
	inOreGo: {
		type: INPUT_TYPES.CHECK,
		checkLabel: 'Do you want to Enroll in OreGO with registration?',
		label: 'OreGO enrollment',
		yup: Yup.boolean().required('Required'),
		title: 'OreGO enrollment',
		defaultValue: true,
	},
	registrationRenewalReminder: {
		type: INPUT_TYPES.CHECK,
		checkLabel: 'Do you want to receive registration renewal reminders by email?',
		label: 'Registration renewal reminder',
		yup: Yup.boolean().required('Required'),
		title: 'Registration renewal reminder',
		defaultValue: true,
	},
	applyingForWildlifeParksPermit: {
		type: INPUT_TYPES.CHECK,
		checkLabel: 'Do you want to apply for a wildlife park permit?',
		label: 'Wildlife park permit',
		yup: Yup.boolean().required('Required'),
		title: 'Wildlife park permit',
		defaultValue: true,
	},
	stateStationed: {
		type: INPUT_TYPES.TEXT_INPUT,
		inputType: 'text',
		label: 'State Stationed for Military',
		yup: Yup.string().oneOf(
			abbrevStateNamesArr,
			'Please enter a valid US state abbreviation. E.g. enter CA for California.',
		),
		title: 'State Stationed for Military',
		defaultValue: '',
	},
	// vehicleStorageAddress: {
	// 	type: INPUT_TYPES.ADDRESS,
	// 	inputType: 'text',
	// 	label: 'Vehicle storage address',
	// 	yup: Yup.string(),
	// 	title: 'Vehicle storage address',
	// },
	eyeColor: {
		type: INPUT_TYPES.TEXT_INPUT,
		inputType: 'text',
		label: 'Eye Color',
		yup: Yup.string().nullable().required('Required'),
		title: 'Eye Color as in Drivers License',
		defaultValue: 'Brown',
	},
};

export const usStatesForSelect = [
	{ value: 'AL', text: 'Alabama' },
	{ value: 'AK', text: 'Alaska' },
	{ value: 'AZ', text: 'Arizona' },
	{ value: 'AR', text: 'Arkansas' },
	{ value: 'CA', text: 'California' },
	{ value: 'CO', text: 'Colorado' },
	{ value: 'CT', text: 'Connecticut' },
	{ value: 'DC', text: 'Washington, D.C.' },
	{ value: 'DE', text: 'Delaware' },
	{ value: 'FL', text: 'Florida' },
	{ value: 'GA', text: 'Georgia' },
	{ value: 'HI', text: 'Hawaii' },
	{ value: 'ID', text: 'Idaho' },
	{ value: 'IL', text: 'Illinois' },
	{ value: 'IN', text: 'Indiana' },
	{ value: 'IA', text: 'Iowa' },
	{ value: 'KS', text: 'Kansas' },
	{ value: 'KY', text: 'Kentucky' },
	{ value: 'LA', text: 'Louisiana' },
	{ value: 'ME', text: 'Maine' },
	{ value: 'MD', text: 'Maryland' },
	{ value: 'MA', text: 'Massachusetts' },
	{ value: 'MI', text: 'Michigan' },
	{ value: 'MN', text: 'Minnesota' },
	{ value: 'MS', text: 'Mississippi' },
	{ value: 'MO', text: 'Missouri' },
	{ value: 'MT', text: 'Montana' },
	{ value: 'NE', text: 'Nebraska' },
	{ value: 'NV', text: 'Nevada' },
	{ value: 'NH', text: 'New Hampshire' },
	{ value: 'NJ', text: 'New Jersey' },
	{ value: 'NM', text: 'New Mexico' },
	{ value: 'NY', text: 'New York' },
	{ value: 'NC', text: 'North Carolina' },
	{ value: 'ND', text: 'North Dakota' },
	{ value: 'OH', text: 'Ohio' },
	{ value: 'OK', text: 'Oklahoma' },
	{ value: 'OR', text: 'Oregon' },
	{ value: 'PA', text: 'Pennsylvania' },
	{ value: 'RI', text: 'Rhode Island' },
	{ value: 'SC', text: 'South Carolina' },
	{ value: 'SD', text: 'South Dakota' },
	{ value: 'TN', text: 'Tennessee' },
	{ value: 'TX', text: 'Texas' },
	{ value: 'UT', text: 'Utah' },
	{ value: 'VT', text: 'Vermont' },
	{ value: 'VA', text: 'Virginia' },
	{ value: 'WA', text: 'Washington' },
	{ value: 'WV', text: 'West Virginia' },
	{ value: 'WI', text: 'Wisconsin' },
	{ value: 'WY', text: 'Wyoming' },
];

export const usStatesArray = [
	'Alabama',
	'Alaska',
	'American Samoa',
	'Arizona',
	'Arkansas',
	'California',
	'Colorado',
	'Connecticut',
	'Delaware',
	'District of Columbia',
	'Federated States of Micronesia',
	'Florida',
	'Georgia',
	'Guam',
	'Hawaii',
	'Idaho',
	'Illinois',
	'Indiana',
	'Iowa',
	'Kansas',
	'Kentucky',
	'Louisiana',
	'Maine',
	'Marshall Islands',
	'Maryland',
	'Massachusetts',
	'Michigan',
	'Minnesota',
	'Mississippi',
	'Missouri',
	'Montana',
	'Nebraska',
	'Nevada',
	'New Hampshire',
	'New Jersey',
	'New Mexico',
	'New York',
	'North Carolina',
	'North Dakota',
	'Northern Mariana Islands',
	'Ohio',
	'Oklahoma',
	'Oregon',
	'Palau',
	'Pennsylvania',
	'Puerto Rico',
	'Rhode Island',
	'South Carolina',
	'South Dakota',
	'Tennessee',
	'Texas',
	'Utah',
	'Vermont',
	'Virgin Island',
	'Virginia',
	'Washington',
	'Washington, D.C.',
	'West Virginia',
	'Wisconsin',
	'Wyoming',
];

export const CREDIT_APP_FIELD_IDS = {
	DOWN_PAYMENT_AMT: 'downpaymentAmt',
	LOAN_TERM: 'loanTerm',
	PHONE_NUMBER: 'phoneNumber',
	DOB: 'dob',
	SSN: 'ssn',
	MARITAL_STATUS: 'maritalStatus',
	HOME_ADDRESS_SAME_AS_ID_ADDRESS: 'homeAddressSameAsIdAddress',
	HOUSING_OWNERSHIP: 'housingOwnership',
	HOME_MOVE_IN_DATE: 'homeMoveInDate',
	MONTHLY_AMT: 'monthlyAmt',
	EMPLOYMENT_STATUS: 'employmentStatus',
	MONTHLY_GROSS_INCOME: 'monthlyGrossIncome',
	EMPLOYER_NAME: 'employerName',
	EMPLOYER_PHONE_NUMBER: 'employerPhoneNumber',
	OCCUPATION: 'occupation',
	JOB_START_DATE: 'jobStartDate',
	NOTE_TO_LENDER: 'noteToLender',
};

export const FINANCING_BANK_NAME_ENUM = {
	FRF: 'FRF',
	IRONHORSE: 'IRONHORSE',
};

export const FINANCING_BANK_NAME_ENUM_DISPLAY = {
	[FINANCING_BANK_NAME_ENUM.FRF]: 'Freedom Road Financial',
	[FINANCING_BANK_NAME_ENUM.IRONHORSE]: 'Ironhorse Funding',
};

export const COLORS = {
	PRIMARY: {
		name: 'primary',
		code: process.env.REACT_APP_PRIMARY_COLOR,
	},
	SECONDARY: {
		name: 'secondary',
		code: process.env.REACT_APP_SECONDARY_COLOR,
	},
	SUCCESS: {
		name: 'success',
		code: process.env.REACT_APP_SUCCESS_COLOR,
	},
	INFO: {
		name: 'info',
		code: process.env.REACT_APP_INFO_COLOR,
	},
	WARNING: {
		name: 'warning',
		code: process.env.REACT_APP_WARNING_COLOR,
	},
	DANGER: {
		name: 'danger',
		code: process.env.REACT_APP_DANGER_COLOR,
	},
	DARK: {
		name: 'dark',
		code: process.env.REACT_APP_DARK_COLOR,
	},
	LIGHT: {
		name: 'light',
		code: process.env.REACT_APP_LIGHT_COLOR,
	},
	// Color Hex codes
	BACKGROUND_GRAY: {
		name: 'backgroundGray',
		code: '#f8f9fa',
	},
	BORDER_GRAY: {
		name: 'borderGray',
		code: 'var(--bs-card-border-color)',
	},
};

// Used for FRF credit app. Don't change!
export const STATE_ABBREV_TO_STATE_NAME = {
	AL: 'Alabama',
	AK: 'Alaska',
	AZ: 'Arizona',
	AR: 'Arkansas',
	CA: 'California',
	CO: 'Colorado',
	CT: 'Connecticut',
	DE: 'Delaware',
	FL: 'Florida',
	GA: 'Georgia',
	HI: 'Hawaii',
	ID: 'Idaho',
	IL: 'Illinois',
	IN: 'Indiana',
	IA: 'Iowa',
	KS: 'Kansas',
	KY: 'Kentucky',
	LA: 'Louisiana',
	ME: 'Maine',
	MD: 'Maryland',
	MA: 'Massachusetts',
	MI: 'Michigan',
	MN: 'Minnesota',
	MS: 'Mississippi',
	MO: 'Missouri',
	MT: 'Montana',
	NE: 'Nebraska',
	NV: 'Nevada',
	NH: 'New Hampshire',
	NJ: 'New Jersey',
	NM: 'New Mexico',
	NY: 'New York',
	NC: 'North Carolina',
	ND: 'North Dakota',
	OH: 'Ohio',
	OK: 'Oklahoma',
	OR: 'Oregon',
	PA: 'Pennsylvania',
	RI: 'Rhode Island',
	SC: 'South Carolina',
	SD: 'South Dakota',
	TN: 'Tennessee',
	TX: 'Texas',
	UT: 'Utah',
	VT: 'Vermont',
	VA: 'Virginia',
	WA: 'Washington',
	WV: 'West Virginia',
	WI: 'Wisconsin',
	WY: 'Wyoming',
};

export const TITLING_AGENT_ENUM = {
	LENDER: 'LENDER',
	EKHO: 'EKHO',
	NONE: 'NONE',
};

// UPDATED JAN 2 2024
// Note: If an APR is not specified for a given term, it means lender doesn't offer it. If newVehicleApr is not defined, DON'T LIST THAT TEIR
// export const ekhoFinancingPrograms = {
// 	[FINANCING_BANK_NAME_ENUM.FRF]: {
// 		STREET_DIRT_PROGRAM: {
// 			programKey: 'STREET_DIRT_PROGRAM',
// 			lastUpdated: 'January 2, 2024',
// 			minimumLoanAmount: 2500,
// 			loanApprovalGoodForDays: 30,
// 			tiers: [
// 				{
// 					tierNum: 1,
// 					creditScoreMax: 850,
// 					creditScoreMin: 730,
// 					terms: {
// 						24: {
// 							numMonths: 24,
// 							newVehicleApr: 0.0899,
// 							usedVehicleApr: 0.0999,
// 						},
// 						36: {
// 							numMonths: 36,
// 							newVehicleApr: 0.0899,
// 							usedVehicleApr: 0.0999,
// 						},
// 						48: {
// 							numMonths: 48,
// 							newVehicleApr: 0.0899,
// 							usedVehicleApr: 0.0999,
// 						},
// 						60: {
// 							numMonths: 60,
// 							newVehicleApr: 0.0999,
// 							usedVehicleApr: 0.1099,
// 						},
// 						72: {
// 							numMonths: 72,
// 							newVehicleApr: 0.1099,
// 							usedVehicleApr: 0.1199,
// 						},
// 						84: {
// 							numMonths: 84,
// 							newVehicleApr: 0.1129,
// 							usedVehicleApr: 0.1299,
// 						},
// 					},
// 				},
// 				{
// 					tierNum: 2,
// 					creditScoreMax: 729,
// 					creditScoreMin: 700,
// 					terms: {
// 						24: {
// 							numMonths: 24,
// 							newVehicleApr: 0.0999,
// 							usedVehicleApr: 0.1099,
// 						},
// 						36: {
// 							numMonths: 36,
// 							newVehicleApr: 0.0999,
// 							usedVehicleApr: 0.1099,
// 						},
// 						48: {
// 							numMonths: 48,
// 							newVehicleApr: 0.0999,
// 							usedVehicleApr: 0.1099,
// 						},
// 						60: {
// 							numMonths: 60,
// 							newVehicleApr: 0.1099,
// 							usedVehicleApr: 0.1199,
// 						},
// 						72: {
// 							numMonths: 72,
// 							newVehicleApr: 0.1199,
// 							usedVehicleApr: 0.1299,
// 						},
// 						84: {
// 							numMonths: 84,
// 							newVehicleApr: 0.1299,
// 							usedVehicleApr: 0.1399,
// 						},
// 					},
// 				},
// 				{
// 					tierNum: 3,
// 					creditScoreMax: 699,
// 					creditScoreMin: 675,
// 					terms: {
// 						24: {
// 							numMonths: 24,
// 							newVehicleApr: 0.1199,
// 							usedVehicleApr: 0.1299,
// 						},
// 						36: {
// 							numMonths: 36,
// 							newVehicleApr: 0.1199,
// 							usedVehicleApr: 0.1299,
// 						},
// 						48: {
// 							numMonths: 48,
// 							newVehicleApr: 0.1199,
// 							usedVehicleApr: 0.1299,
// 						},
// 						60: {
// 							numMonths: 60,
// 							newVehicleApr: 0.1399,
// 							usedVehicleApr: 0.1499,
// 						},
// 						72: {
// 							numMonths: 72,
// 							newVehicleApr: 0.1599,
// 							usedVehicleApr: 0.1549,
// 						},
// 						84: {
// 							numMonths: 84,
// 							newVehicleApr: 0.1499,
// 							usedVehicleApr: null,
// 						},
// 					},
// 				},
// 				{
// 					tierNum: 4,
// 					creditScoreMax: 674,
// 					creditScoreMin: 660,
// 					terms: {
// 						24: {
// 							numMonths: 24,
// 							newVehicleApr: 0.1499,
// 							usedVehicleApr: 0.1599,
// 						},
// 						36: {
// 							numMonths: 36,
// 							newVehicleApr: 0.1499,
// 							usedVehicleApr: 0.1599,
// 						},
// 						48: {
// 							numMonths: 48,
// 							newVehicleApr: 0.1499,
// 							usedVehicleApr: 0.1599,
// 						},
// 						60: {
// 							numMonths: 60,
// 							newVehicleApr: 0.1549,
// 							usedVehicleApr: 0.1649,
// 						},
// 						72: {
// 							numMonths: 72,
// 							newVehicleApr: 0.1599,
// 							usedVehicleApr: 0.1699,
// 						},
// 						84: {
// 							numMonths: 84,
// 							newVehicleApr: 0.1649,
// 							usedVehicleApr: null,
// 						},
// 					},
// 				},
// 				{
// 					tierNum: 5,
// 					creditScoreMax: 659,
// 					creditScoreMin: 0,
// 					terms: {
// 						24: {
// 							numMonths: 24,
// 							newVehicleApr: 0.1699,
// 							usedVehicleApr: 0.1899,
// 						},
// 						36: {
// 							numMonths: 36,
// 							newVehicleApr: 0.1699,
// 							usedVehicleApr: 0.1899,
// 						},
// 						48: {
// 							numMonths: 48,
// 							newVehicleApr: 0.1699,
// 							usedVehicleApr: 0.1899,
// 						},
// 						60: {
// 							numMonths: 60,
// 							newVehicleApr: 0.1799,
// 							usedVehicleApr: 0.1999,
// 						},
// 						72: {
// 							numMonths: 72,
// 							newVehicleApr: 0.1899,
// 							usedVehicleApr: null,
// 						},
// 					},
// 				},
// 			],
// 			titlingAgent: TITLING_AGENT_ENUM.EKHO,
// 		},
// 		ATV_ORV_PROGRAM: {
// 			programKey: 'ATV_ORV_PROGRAM',
// 			lastUpdated: 'January 2, 2024', // The current date, assuming this is the update date.
// 			minimumLoanAmount: 2500,
// 			loanApprovalGoodForDays: 30,
// 			tiers: [
// 				{
// 					tierNum: 1,
// 					creditScoreMax: 850, // Assuming the max credit score for Tier 1 is 850
// 					creditScoreMin: 730,
// 					terms: {
// 						24: {
// 							numMonths: 24,
// 							newVehicleApr: 0.0999,
// 							usedVehicleApr: 0.1099,
// 						},
// 						36: {
// 							numMonths: 36,
// 							newVehicleApr: 0.0999,
// 							usedVehicleApr: 0.1099,
// 						},
// 						48: {
// 							numMonths: 48,
// 							newVehicleApr: 0.0999,
// 							usedVehicleApr: 0.1099,
// 						},
// 						60: {
// 							numMonths: 60,
// 							newVehicleApr: 0.1099,
// 							usedVehicleApr: 0.1199,
// 						},
// 						72: {
// 							numMonths: 72,
// 							newVehicleApr: 0.1149,
// 							usedVehicleApr: 0.1249,
// 						},
// 						84: {
// 							numMonths: 84,
// 							newVehicleApr: 0.1199,
// 							usedVehicleApr: null,
// 						},
// 					},
// 				},
// 				{
// 					tierNum: 2,
// 					creditScoreMax: 729,
// 					creditScoreMin: 700,
// 					terms: {
// 						24: {
// 							numMonths: 24,
// 							newVehicleApr: 0.1099,
// 							usedVehicleApr: 0.1129,
// 						},
// 						36: {
// 							numMonths: 36,
// 							newVehicleApr: 0.1099,
// 							usedVehicleApr: 0.1129,
// 						},
// 						48: {
// 							numMonths: 48,
// 							newVehicleApr: 0.1099,
// 							usedVehicleApr: 0.1129,
// 						},
// 						60: {
// 							numMonths: 60,
// 							newVehicleApr: 0.1169,
// 							usedVehicleApr: 0.1269,
// 						},
// 						72: {
// 							numMonths: 72,
// 							newVehicleApr: 0.1249,
// 							usedVehicleApr: 0.1349,
// 						},
// 						84: {
// 							numMonths: 84,
// 							newVehicleApr: 0.1329,
// 							usedVehicleApr: null,
// 						},
// 					},
// 				},
// 				{
// 					tierNum: 3,
// 					creditScoreMax: 699,
// 					creditScoreMin: 675,
// 					terms: {
// 						24: {
// 							numMonths: 24,
// 							newVehicleApr: 0.1399,
// 							usedVehicleApr: 0.1499,
// 						},
// 						36: {
// 							numMonths: 36,
// 							newVehicleApr: 0.1399,
// 							usedVehicleApr: 0.1499,
// 						},
// 						48: {
// 							numMonths: 48,
// 							newVehicleApr: 0.1399,
// 							usedVehicleApr: 0.1499,
// 						},
// 						60: {
// 							numMonths: 60,
// 							newVehicleApr: 0.1499,
// 							usedVehicleApr: 0.1599,
// 						},
// 						72: {
// 							numMonths: 72,
// 							newVehicleApr: 0.1549,
// 							usedVehicleApr: 0.1649,
// 						},
// 						84: {
// 							numMonths: 84,
// 							newVehicleApr: 0.1599,
// 							usedVehicleApr: null,
// 						},
// 					},
// 				},
// 				{
// 					tierNum: 4,
// 					creditScoreMax: 674,
// 					creditScoreMin: 660,
// 					terms: {
// 						24: {
// 							numMonths: 24,
// 							newVehicleApr: 0.1599,
// 							usedVehicleApr: 0.1699,
// 						},
// 						36: {
// 							numMonths: 36,
// 							newVehicleApr: 0.1599,
// 							usedVehicleApr: 0.1699,
// 						},
// 						48: {
// 							numMonths: 48,
// 							newVehicleApr: 0.1599,
// 							usedVehicleApr: 0.1699,
// 						},
// 						60: {
// 							numMonths: 60,
// 							newVehicleApr: 0.1649,
// 							usedVehicleApr: 0.1749,
// 						},
// 						72: {
// 							numMonths: 72,
// 							newVehicleApr: 0.1699,
// 							usedVehicleApr: null,
// 						},
// 					},
// 				},
// 				{
// 					tierNum: 5,
// 					creditScoreMax: 659,
// 					creditScoreMin: 0,
// 					terms: {
// 						24: {
// 							numMonths: 24,
// 							newVehicleApr: 0.1799,
// 							usedVehicleApr: 0.1899,
// 						},
// 						36: {
// 							numMonths: 36,
// 							newVehicleApr: 0.1799,
// 							usedVehicleApr: 0.1899,
// 						},
// 						48: {
// 							numMonths: 48,
// 							newVehicleApr: 0.1799,
// 							usedVehicleApr: 0.1899,
// 						},
// 						60: {
// 							numMonths: 60,
// 							newVehicleApr: 0.1899,
// 							usedVehicleApr: 0.1999,
// 						},
// 						72: {
// 							numMonths: 72,
// 							newVehicleApr: 0.1999,
// 							usedVehicleApr: null,
// 						},
// 					},
// 				},
// 			],
// 			titlingAgent: TITLING_AGENT_ENUM.EKHO,
// 		},
// 		SNOWMOBILE_PWC_GOLF_SCOOTER_PROGRAM: {
// 			programKey: 'SNOWMOBILE_PWC_GOLF_SCOOTER_PROGRAM',
// 			lastUpdated: 'January 2, 2024', // Assuming the last updated date is today's date.
// 			minimumLoanAmount: 2500,
// 			loanApprovalGoodForDays: 30,
// 			tiers: [
// 				{
// 					tierNum: 1,
// 					creditScoreMax: 850, // Assuming the max credit score for Tier 1 is 850
// 					creditScoreMin: 730,
// 					terms: {
// 						24: {
// 							numMonths: 24,
// 							newVehicleApr: 0.0999,
// 							usedVehicleApr: 0.1099,
// 						},
// 						36: {
// 							numMonths: 36,
// 							newVehicleApr: 0.0999,
// 							usedVehicleApr: 0.1099,
// 						},
// 						48: {
// 							numMonths: 48,
// 							newVehicleApr: 0.0999,
// 							usedVehicleApr: 0.1099,
// 						},
// 						60: {
// 							numMonths: 60,
// 							newVehicleApr: 0.1149,
// 							usedVehicleApr: 0.1249,
// 						},
// 						72: {
// 							numMonths: 72,
// 							newVehicleApr: 0.1199,
// 							usedVehicleApr: 0.1299,
// 						},
// 						84: {
// 							numMonths: 84,
// 							newVehicleApr: 0.1249,
// 							usedVehicleApr: null,
// 						},
// 					},
// 				},
// 				{
// 					tierNum: 2,
// 					creditScoreMax: 729,
// 					creditScoreMin: 700,
// 					terms: {
// 						24: {
// 							numMonths: 24,
// 							newVehicleApr: 0.1149,
// 							usedVehicleApr: 0.1179,
// 						},
// 						36: {
// 							numMonths: 36,
// 							newVehicleApr: 0.1149,
// 							usedVehicleApr: 0.1179,
// 						},
// 						48: {
// 							numMonths: 48,
// 							newVehicleApr: 0.1149,
// 							usedVehicleApr: 0.1179,
// 						},
// 						60: {
// 							numMonths: 60,
// 							newVehicleApr: 0.1199,
// 							usedVehicleApr: 0.1299,
// 						},
// 						72: {
// 							numMonths: 72,
// 							newVehicleApr: 0.1299,
// 							usedVehicleApr: 0.1399,
// 						},
// 						84: {
// 							numMonths: 84,
// 							newVehicleApr: 0.1399,
// 							usedVehicleApr: null,
// 						},
// 					},
// 				},
// 				{
// 					tierNum: 3,
// 					creditScoreMax: 699,
// 					creditScoreMin: 675,
// 					terms: {
// 						24: {
// 							numMonths: 24,
// 							newVehicleApr: 0.1449,
// 							usedVehicleApr: 0.1549,
// 						},
// 						36: {
// 							numMonths: 36,
// 							newVehicleApr: 0.1449,
// 							usedVehicleApr: 0.1549,
// 						},
// 						48: {
// 							numMonths: 48,
// 							newVehicleApr: 0.1449,
// 							usedVehicleApr: 0.1549,
// 						},
// 						60: {
// 							numMonths: 60,
// 							newVehicleApr: 0.1549,
// 							usedVehicleApr: 0.1649,
// 						},
// 						72: {
// 							numMonths: 72,
// 							newVehicleApr: 0.1599,
// 							usedVehicleApr: 0.1699,
// 						},
// 						84: {
// 							numMonths: 84,
// 							newVehicleApr: 0.1699,
// 							usedVehicleApr: null,
// 						},
// 					},
// 				},
// 				{
// 					tierNum: 4,
// 					creditScoreMax: 674,
// 					creditScoreMin: 660,
// 					terms: {
// 						24: {
// 							numMonths: 24,
// 							newVehicleApr: 0.1649,
// 							usedVehicleApr: 0.1749,
// 						},
// 						36: {
// 							numMonths: 36,
// 							newVehicleApr: 0.1649,
// 							usedVehicleApr: 0.1749,
// 						},
// 						48: {
// 							numMonths: 48,
// 							newVehicleApr: 0.1649,
// 							usedVehicleApr: 0.1749,
// 						},
// 						60: {
// 							numMonths: 60,
// 							newVehicleApr: 0.1699,
// 							usedVehicleApr: 0.1799,
// 						},
// 						72: {
// 							numMonths: 72,
// 							newVehicleApr: 0.1749,
// 							usedVehicleApr: null,
// 						},
// 						84: {
// 							numMonths: 84,
// 							newVehicleApr: 0.1799,
// 							usedVehicleApr: null,
// 						},
// 					},
// 				},
// 				{
// 					tierNum: 5,
// 					creditScoreMax: 659,
// 					creditScoreMin: 0,
// 					terms: {
// 						24: {
// 							numMonths: 24,
// 							newVehicleApr: 0.1799,
// 							usedVehicleApr: 0.1899,
// 						},
// 						36: {
// 							numMonths: 36,
// 							newVehicleApr: 0.1799,
// 							usedVehicleApr: 0.1899,
// 						},
// 						48: {
// 							numMonths: 48,
// 							newVehicleApr: 0.1799,
// 							usedVehicleApr: 0.1899,
// 						},
// 						60: {
// 							numMonths: 60,
// 							newVehicleApr: 0.1899,
// 							usedVehicleApr: 0.1999,
// 						},
// 						72: {
// 							numMonths: 72,
// 							newVehicleApr: 0.1999,
// 							usedVehicleApr: null,
// 						},
// 					},
// 				},
// 			],
// 			titlingAgent: TITLING_AGENT_ENUM.EKHO,
// 		},
// 	},
// };
export const EKHO_LOAN_TERM_OPTIONS = [24, 36, 48, 60, 72, 84];

export const TEMP_TAG_FEE = 20;
export const VI_PROCESSING_FEE = 165;
export const CG_PROCESSING_FEE = 30;
export const PAPERWORK_FEE = 20; // shipping of documents etc.

// Used in checkout to produce registration options, and in backend
export const TAR_PROCESS_ENUM = {
	ASSISTED: 'ASSISTED',
	AUTOMATED: 'AUTOMATED',
	ASSISTED_TITLING: 'ASSISTED_TITLING',
	AUTOMATED_TITLING: 'AUTOMATED_TITLING',
	NONE: 'NONE',
};

export const TAR_AGENT_ENUM = {
	BUYER: 'BUYER',
	EKHO: 'EKHO', // deprecated
	VI: 'VI',
	CG: 'CG',
	NONE: 'NONE',
};

export const STATE_DATA_TAR_PROCESS_KEYS = {
	automatedTARSupported: 'automatedTARSupported',
	assistedTARNotSupported: 'assistedTARNotSupported',
	automatedTitlingSupported: 'automatedTitlingSupported',
	assistedTitlingNotSupported: 'assistedTitlingNotSupported',
	noneSupported: 'noneSupported',
};

export const TAR_PROCESS_TO_STATE_PROCESS_MAP_KEY = {
	[TAR_PROCESS_ENUM.ASSISTED]: STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported,
	[TAR_PROCESS_ENUM.AUTOMATED]: STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported,
	[TAR_PROCESS_ENUM.ASSISTED_TITLING]: STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported,
	[TAR_PROCESS_ENUM.AUTOMATED_TITLING]: STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported,
	[TAR_PROCESS_ENUM.NONE]: STATE_DATA_TAR_PROCESS_KEYS.noneSupported,
};

// the enum we use on the purchasedVehicle.paymentInfo.paymentSelectionType
export const PAYMENT_SELECTION_TYPES = {
	cash: 'cash',
	cashEarly: 'cashEarly',
	nativeFinancing: 'nativeFinancing',
	otherFinancing: 'otherFinancing',
	checkoutFullPayment: 'checkoutFullPayment',
	klarnaCheckoutFullPayment: 'klarnaCheckoutFullPayment',
};

export const INSURANCE_SELECTION_TYPES = {
	skipInsurance: 'skipInsurance',
	purchaseInsurance: 'purchaseInsurance',
	useExistingInsurance: 'useExistingInsurance',
	provideBasicDetails: 'provideBasicDetails',
};

export const INTERNAL_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	DUAL_SPORT: 'DualSport',
	TRUCK: 'Truck',
	COMMERCIAL: 'Commercial',
	TRAILER: 'Trailer',
	MOPED: 'Moped',
	OHV: 'OHV',
	VESSEL: 'Vessel',
	NEV: 'NeighborhoodElectricVehicle',
	LOW_SPEED: 'LowSpeed',
	GO_KART: 'Gokart',
	E_BIKE: 'E-Bike',
	ATV: 'ATV',
	ORV: 'ORV',
};

export const CG_VEHICLE_TYPE_ENUM = {
	// Keys should match our internal vehicle type enum values
	[INTERNAL_VEHICLE_TYPE_ENUM.ATV]: 'ATV',
	[INTERNAL_VEHICLE_TYPE_ENUM.ORV]: 'ORV',
	[INTERNAL_VEHICLE_TYPE_ENUM.LOW_SPEED]: 'LOW_SPEED',
	[INTERNAL_VEHICLE_TYPE_ENUM.OHV]: 'OHV',
};

export const INTERNAL_FUEL_TYPE_ENUM = {
	GASOLINE: 'Gasoline',
	DIESEL: 'Diesel',
	HYDROGEN_FUEL_CELL: 'HydrogenFuelCell',
	ELECTRIC: 'Electric',
	NATURAL_GAS_POWERED: 'NaturalGasPowered',
	FLEX_FUEL: 'FlexFuel',
	HYBRID_DIESEL_ELECTRIC: 'HybridDieselElectric',
	HYBRID_GASOLINE_ELECTRIC: 'HybridGasolineElectric',
};

export const BANK_INSURANCE_REQS = {
	[FINANCING_BANK_NAME_ENUM.FRF]: {
		[INTERNAL_VEHICLE_TYPE_ENUM.MOPED]: {
			required: true,
			minimumTotalPrice: 5000,
		},
		[INTERNAL_VEHICLE_TYPE_ENUM.MOTORCYCLE]: {
			required: true,
			minimumTotalPrice: 5000,
		},
		[INTERNAL_VEHICLE_TYPE_ENUM.LOW_SPEED]: {
			required: true,
			minimumTotalPrice: 5000,
		},
		[INTERNAL_VEHICLE_TYPE_ENUM.NEV]: {
			required: true,
			minimumTotalPrice: 5000,
		},
		[INTERNAL_VEHICLE_TYPE_ENUM.PASSENGER]: {
			required: true,
			minimumTotalPrice: 5000,
		},
		[INTERNAL_VEHICLE_TYPE_ENUM.COMMERCIAL]: {
			required: true,
			minimumTotalPrice: 5000,
		},
		[INTERNAL_VEHICLE_TYPE_ENUM.TRAILER]: {
			required: true,
			minimumTotalPrice: 5000,
		},
		[INTERNAL_VEHICLE_TYPE_ENUM.TRUCK]: {
			required: true,
			minimumTotalPrice: 5000,
		},
		[INTERNAL_VEHICLE_TYPE_ENUM.OHV]: {
			required: false,
		},
		[INTERNAL_VEHICLE_TYPE_ENUM.VESSEL]: {
			required: false,
		},
		[INTERNAL_VEHICLE_TYPE_ENUM.GO_KART]: {
			required: false,
		},
		[INTERNAL_VEHICLE_TYPE_ENUM.E_BIKE]: {
			required: false,
		},
		[INTERNAL_VEHICLE_TYPE_ENUM.ATV]: {
			required: false,
		},
		[INTERNAL_VEHICLE_TYPE_ENUM.ORV]: {
			required: false,
		},
		[INTERNAL_VEHICLE_TYPE_ENUM.DUAL_SPORT]: {
			required: false,
		},
	},
	[FINANCING_BANK_NAME_ENUM.IRONHORSE]: {
		[INTERNAL_VEHICLE_TYPE_ENUM.MOPED]: {
			required: true,
			minimumTotalPrice: 0,
		},
		[INTERNAL_VEHICLE_TYPE_ENUM.MOTORCYCLE]: {
			required: true,
			minimumTotalPrice: 0,
		},
		[INTERNAL_VEHICLE_TYPE_ENUM.LOW_SPEED]: {
			required: true,
			minimumTotalPrice: 0,
		},
		[INTERNAL_VEHICLE_TYPE_ENUM.NEV]: {
			required: true,
			minimumTotalPrice: 0,
		},
		[INTERNAL_VEHICLE_TYPE_ENUM.PASSENGER]: {
			required: true,
			minimumTotalPrice: 0,
		},
		[INTERNAL_VEHICLE_TYPE_ENUM.COMMERCIAL]: {
			required: true,
			minimumTotalPrice: 0,
		},
		[INTERNAL_VEHICLE_TYPE_ENUM.TRAILER]: {
			required: true,
			minimumTotalPrice: 0,
		},
		[INTERNAL_VEHICLE_TYPE_ENUM.TRUCK]: {
			required: true,
			minimumTotalPrice: 0,
		},
		[INTERNAL_VEHICLE_TYPE_ENUM.OHV]: {
			required: true,
			minimumTotalPrice: 15000,
		},
		[INTERNAL_VEHICLE_TYPE_ENUM.VESSEL]: {
			required: true,
			minimumTotalPrice: 0,
		},
		[INTERNAL_VEHICLE_TYPE_ENUM.GO_KART]: {
			required: true,
			minimumTotalPrice: 15000,
		},
		[INTERNAL_VEHICLE_TYPE_ENUM.E_BIKE]: {
			required: true,
			minimumTotalPrice: 15000,
		},
		[INTERNAL_VEHICLE_TYPE_ENUM.ATV]: {
			required: true,
			minimumTotalPrice: 15000,
		},
		[INTERNAL_VEHICLE_TYPE_ENUM.ORV]: {
			required: true,
			minimumTotalPrice: 15000,
		},
		[INTERNAL_VEHICLE_TYPE_ENUM.DUAL_SPORT]: {
			required: false,
			minimumTotalPrice: 15000,
		},
	},
};

// used in buyer portal and other places to determine if insurance is required
export const insuranceReqTypes = {
	validationRequired: 'validationRequired',
	basicInformationRequired: 'basicInformationRequired',
	insuranceNotRequired: 'insuranceNotRequired',
};

export const OEMS_THAT_CAN_OVERRIDE_VEHICLE_IMG_URL = ['stark'];

export const ORDER_CREATION_TYPES = {
	ANTE_PREORDER: 'ANTE_PREORDER',
	ORGANIC: 'ORGANIC',
	PREORDER: 'PREORDER',
	EXISTINGORDER: 'EXISTINGORDER',
	OEMORIGINATED: 'OEMORIGINATED',
	ABANDONEDCART: 'ABANDONEDCART',
	ABANDONED_ANTE_PREORDER: 'ABANDONED_ANTE_PREORDER',
};

export const HOW_IT_WORKS_SECTIONS_ENUM = {
	PREORDER: 'PREORDER',
	PREORDER_CONVERSION: 'PREORDER_CONVERSION',
	ORDER: 'ORDER',
	FINANCING: 'FINANCING',
	INSURANCE: 'INSURANCE',
	TAR_PROCESS_AUTOMATED: 'TAR_PROCESS_AUTOMATED',
	TAR_PROCESS_ASSISTED: 'TAR_PROCESS_ASSISTED',
	TAR_PROCESS_AUTOMATED_TITLING: 'TAR_PROCESS_AUTOMATED_TITLING',
	TAR_PROCESS_ASSISTED_TITLING: 'TAR_PROCESS_ASSISTED_TITLING',
	PAPERWORK: 'PAPERWORK',
	HOME_DELIVERY: 'HOME_DELIVERY',
	PICK_UP: 'PICK_UP',
};

export const HOW_IT_WORKS_SECTIONS = {
	[HOW_IT_WORKS_SECTIONS_ENUM.PREORDER]: {
		id: HOW_IT_WORKS_SECTIONS_ENUM.PREORDER,
		order: 0,
		activeStep: true,
		// or false depending on the context or data
		completed: false,
		// Assuming this step has not been completed yet
		optional: false,
		iconName: 'LockClock',
		title: 'Secure your build slot',
		description: `Place a deposit to secure your vehicle build slot. You'll receive an email once you've placed your preorder.`,
	},
	[HOW_IT_WORKS_SECTIONS_ENUM.PREORDER_CONVERSION]: {
		id: HOW_IT_WORKS_SECTIONS_ENUM.PREORDER_CONVERSION,
		order: 1,
		activeStep: false,
		// or false depending on the context or data
		completed: false,
		// Assuming this step has not been completed yet
		optional: false,
		iconName: 'ShoppingCart',
		title: 'Finalize your order',
		description: `Select your remaining payment, delivery, and registration choices to finalize your order. You'll be invited to complete this step once your preorder has been prioritized.`,
	},
	[HOW_IT_WORKS_SECTIONS_ENUM.ORDER]: {
		id: HOW_IT_WORKS_SECTIONS_ENUM.ORDER,
		order: 1,
		activeStep: true, // or false depending on the context or data
		completed: false, // Assuming this step has not been completed yet
		optional: false,
		iconName: 'ShoppingCart',
		title: 'Provide basic order and contact info',
		description: `Make your payment, delivery, and registration choices here on this Ekho Checkout page. You'll receive an email once you've placed your order.`,
	},
	[HOW_IT_WORKS_SECTIONS_ENUM.FINANCING]: {
		id: HOW_IT_WORKS_SECTIONS_ENUM.FINANCING,
		order: 2,
		activeStep: false,
		completed: false,
		optional: true,
		iconName: 'AccountBalance',
		title: 'Apply for financing',
		description: `If you're financing your purchase, you'll also complete a short financing application in the Ekho Checkout page! We'll let you know if you're approved within minutes.`,
	},
	[HOW_IT_WORKS_SECTIONS_ENUM.INSURANCE]: {
		id: HOW_IT_WORKS_SECTIONS_ENUM.INSURANCE,
		order: 3,
		activeStep: false,
		completed: false,
		optional: false,
		iconName: 'Security',
		title: 'Protect your vehicle',
		description: `If necessary, purchase new or validate existing insurance from within Ekho's platform.`,
	},
	[HOW_IT_WORKS_SECTIONS_ENUM.TAR_PROCESS_AUTOMATED]: {
		id: HOW_IT_WORKS_SECTIONS_ENUM.TAR_PROCESS_AUTOMATED,
		order: 4,
		activeStep: false,
		completed: false,
		optional: false,
		iconName: 'VerifiedUser',
		title: 'Automated registration',
		description: `Let Ekho handle the registration process for you (no trip to the DMV).`,
	},
	[HOW_IT_WORKS_SECTIONS_ENUM.TAR_PROCESS_ASSISTED]: {
		id: HOW_IT_WORKS_SECTIONS_ENUM.TAR_PROCESS_ASSISTED,
		order: 5,
		activeStep: false,
		completed: false,
		optional: false,
		iconName: 'VerifiedUser',
		title: 'Assisted registration',
		description: `Let Ekho help you complete the state registration process.`,
	},
	[HOW_IT_WORKS_SECTIONS_ENUM.TAR_PROCESS_AUTOMATED_TITLING]: {
		id: HOW_IT_WORKS_SECTIONS_ENUM.TAR_PROCESS_AUTOMATED_TITLING,
		order: 5,
		activeStep: false,
		completed: false,
		optional: false,
		iconName: 'VerifiedUser',
		title: 'Automated titling',
		description: `Let Ekho handle the titling process for you (no trip to the DMV).`,
	},
	[HOW_IT_WORKS_SECTIONS_ENUM.TAR_PROCESS_ASSISTED_TITLING]: {
		id: HOW_IT_WORKS_SECTIONS_ENUM.TAR_PROCESS_ASSISTED_TITLING,
		order: 6,
		activeStep: false,
		completed: false,
		optional: false,
		iconName: 'VerifiedUser',
		title: 'Assisted titling',
		description: `Let Ekho help you complete the state titling process.`,
	},
	[HOW_IT_WORKS_SECTIONS_ENUM.PAPERWORK]: {
		id: HOW_IT_WORKS_SECTIONS_ENUM.PAPERWORK,
		order: 7,
		activeStep: false,
		completed: false,
		iconName: 'Task',
		optional: false,
		title: 'Complete your paperwork',
		description: `Sign your sales contracts and any other necessary state documents. We'll provide instructions that'll make this part easy.`,
	},
	[HOW_IT_WORKS_SECTIONS_ENUM.HOME_DELIVERY]: {
		id: HOW_IT_WORKS_SECTIONS_ENUM.HOME_DELIVERY,
		order: 8,
		activeStep: false,
		completed: false,
		optional: false,
		iconName: 'BikeScooter',
		title: 'Take delivery',
		description: 'Take delivery of your vehicle at your specified delivery location.',
	},
	[HOW_IT_WORKS_SECTIONS_ENUM.PICK_UP]: {
		id: HOW_IT_WORKS_SECTIONS_ENUM.PICK_UP,
		order: 9,
		activeStep: false,
		completed: false,
		optional: false,
		iconName: 'BikeScooter',
		title: 'Pick up your vehicle',
		description: 'Pick up your vehicle from your chosen pickup location.',
	},
};

export const EKHO_APPS_ENUM = {
	BUYER_PORTAL: 'BUYER_PORTAL',
	DEALER_PORTAL: 'DEALER_PORTAL',
	ADMIN_PORTAL: 'ADMIN_PORTAL',
	CHECKOUT: 'CHECKOUT',
	INFO_MODAL: 'INFO_MODAL',
};

export const SUPPORT_TOPICS = {
	PAYMENT: {
		key: 'PAYMENT',
		title: 'Payment & financing',
		description: 'Questions about payment options, financing, terms, etc.',
		commsOwnedByEkho: true,
	},
	VEHICLE: {
		key: 'VEHICLE',
		title: 'Vehicle details',
		description:
			"Questions about the vehicle you're purchasing, it's specs, condition, configuration, etc.",
		commsOwnedByEkho: false,
	},
	INSURANCE: {
		key: 'INSURANCE',
		title: 'Insurance',
		description: 'Questions about insurance, state requirements, your options, etc.',
		commsOwnedByEkho: true,
	},
	REGISTRATION: {
		key: 'REGISTRATION',
		title: 'Registration & titling',
		description:
			"Questions about registration, titling, the process, what's required, street legal vs off-road, etc.",
		commsOwnedByEkho: true,
	},
	DELIVERY: {
		key: 'DELIVERY',
		title: 'Delivery',
		description: 'Questions about the delivery process, timing, etc.',
		commsOwnedByEkho: false,
	},
	PICK_UP: {
		key: 'PICK_UP',
		title: 'Pick up',
		description: 'Questions about the pick up process, timing, etc.',
		commsOwnedByEkho: false,
	},
	TECHNICAL: {
		key: 'TECHNICAL',
		title: 'Technical issues',
		description: 'Questions about the checkout process, errors, bugs, etc.',
		commsOwnedByEkho: true,
	},
	EKHO: {
		key: 'EKHO',
		title: 'Ekho',
		description:
			'Ekho partners with vehicle manufacturers, distributors, and dealerships to provide a safe, seamless, online vehicle buying experience.',
		commsOwnedByEkho: true,
	},
};

// Defines when we do web vs mobile rendering in BP and Checkout
export const STACKING_BREAKPOINT = 1150; // in px
export const CHECKOUT_INFO_MAX_WIDTH = 650; // in px
export const WEB_INNER_SIDE_PADDING = 5; // in rem
export const WEB_OUTER_SIDE_PADDING = 2; // in rem
export const WEB_VERTICAL_PADDING = 3; // in rem
export const MOBILE_SIDE_PADDING = 2; // in rem

export const EKHO_PHONE_SUPPORT_SCHEDULE = {
	monday: {
		start: '08:30',
		end: '19:00',
		day: 'monday',
	},
	tuesday: {
		start: '08:30',
		end: '19:00',
		day: 'tuesday',
	},
	wednesday: {
		start: '08:30',
		end: '19:00',
		day: 'wednesday',
	},
	thursday: {
		start: '08:30',
		end: '19:00',
		day: 'thursday',
	},
	friday: {
		start: '08:30',
		end: '19:00',
		day: 'friday',
	},
};

export const SUPPORT_MODAL_STATE = {
	SUPPORT_HUB: 'SUPPPORT_HUB',
	MESSAGE_OEM: 'MESSAGE_OEM',
	MESSAGE_SENT: 'MESSAGE_SENT',
};

export const PICK_UP_LOCATION_TYPE_ENUM = {
	DEALER: 'DEALER',
	EKHO: 'EKHO',
	OEM: 'OEM',
};

export const FEE_ESTIMATE_FIDELITIES = {
	FINAL: 'final',
	INITIAL: 'initial',
	API_ESTIMATE: 'apiEstimate',
	ACTUAL: 'actual',
};

export const GOOGLE_MAP_STYLES = [
	// {
	// 	featureType: 'all',
	// 	elementType: 'labels',
	// 	stylers: [{ visibility: 'off' }],
	// },
	{
		featureType: 'all',
		elementType: 'labels.icon',
		stylers: [{ visibility: 'off' }],
	},
	// {
	// 	featureType: 'road',
	// 	elementType: 'geometry',
	// 	stylers: [{ visibility: 'simplified' }],
	// },
	// {
	// 	featureType: 'road.arterial',
	// 	elementType: 'labels',
	// 	stylers: [{ visibility: 'off' }],
	// },
	{
		featureType: 'poi',
		elementType: 'labels',
		stylers: [{ visibility: 'off' }],
	},
	// {
	// 	featureType: 'water',
	// 	elementType: 'labels',
	// 	stylers: [{ visibility: 'off' }],
	// },
	{
		featureType: 'transit',
		elementType: 'labels',
		stylers: [{ visibility: 'off' }],
	},
];

export const FORMIK_DATE_FIELDS = [
	'dob',
	'dlExpDate',
	'homeMoveInDate',
	'jobStartDate',
	'effectiveDate',
	'expiryDate',
];

// FINANCING APPLICATION CONSTANTS
export const EKHO_FINANCING_APPLICATION_CONSTANTS = {
	MARITAL_STATUS_OPTIONS: {
		SINGLE: 'Single',
		MARRIED: 'Married',
		WIDOWED: 'Widowed',
		DIVORCED: 'Divorced',
		SEPARATED: 'Separated',
	},
	HOUSING_OWNERSHIP_OPTIONS: {
		OWNED: 'Owned',
		RENTED: 'Rented',
		FAMILY: 'Family',
		LIVES_WITH_RELATIVES: 'LivesWithRelatives',
	},
	EMPLOYMENT_STATUS_OPTIONS: {
		EMPLOYED: 'Employed',
		SELF_EMPLOYED: 'SelfEmployed',
		RETIRED: 'Retired',
	},
	INCOME_TYPE_OPTIONS: {
		SPOUSAL_INCOME: 'SpousalIncome',
		CHILD_SUPPORT: 'childSupport',
		DISABILITY: 'disability',
		INVESTMENT: 'investment',
		PENSION: 'pension',
		RENTAL: 'rental',
		RETIREMENT_INCOME: 'retirementIncome',
		SOCIAL_SECURITY: 'socialSecurity',
		ALIMONY: 'alimony',
		UNEMPLOYMENT: 'unemployment',
		OTHER: 'other',
	},
	INCOME_TYPE_DESCRIPTIONS: {
		SPOUSAL_INCOME: 'The income that your partner earns.',
		CHILD_SUPPORT: 'The income that you receive from child support payments.',
		DISABILITY: 'The income that you receive from disability payments.',
		INVESTMENT:
			'The income that you receive from investments (e.g. dividends, interest, etc.).',
		PENSION: 'The income that you receive from a pension.',
		RENTAL: 'The income that you receive from rental properties.',
		RETIREMENT_INCOME: 'The income that you receive from retirement accounts.',
		SOCIAL_SECURITY: 'The income that you receive from social security payments.',
		ALIMONY: 'The income that you receive from alimony payments.',
		UNEMPLOYMENT: 'The income that you receive from unemployment benefits.',
		OTHER: 'Any other income that you receive that is not listed above.',
		VERIFY_IDENTITY: 'Please have the Applicant Call Freedom Road to Verify Identity',
	},
	REFERENCE_RELATIONSHIP_OPTIONS: {
		EMPLOYER: 'Employer',
		FRIEND: 'Friend',
		OTHER: 'Other',
		PARENT: 'Parent',
		RELATIVE: 'Relative',
		SPOUSE: 'Spouse',
	},
};

export const EKHO_FINANCING_STIPULATIONS_KEYS = {
	CALL_FRF_TO_VERIFY_IDENTITY_STIP: 'CALL_FRF_TO_VERIFY_IDENTITY_STIP',
	PAYOFF_OUTSTANDING_LOAN_STIP: 'PAYOFF_OUTSTANDING_LOAN_STIP',
	NOTARIZED_CONTRACT_STIP: 'NOTARIZED_CONTRACT_STIP',
	PERSONAL_REFERENCES_STIP: 'PERSONAL_REFERENCES_STIP',
	PROOF_OF_INCOME_STIP: 'PROOF_OF_INCOME_STIP',
	ADDITIONAL_INCOME_STIP: 'ADDITIONAL_INCOME_STIP',
	PROVIDE_CURRENT_WORK_PHONE_NUMBER_STIP: 'PROVIDE_CURRENT_WORK_PHONE_NUMBER_STIP',
	FIVE_PERSONAL_REFERENCES_STIP: 'FIVE_PERSONAL_REFERENCES_STIP',
	MAX_FINANCED_STIP: 'MAX_FINANCED_STIP',
	PROOF_OF_RESIDENCE_STIP: 'PROOF_OF_RESIDENCE_STIP',
	PROOF_OF_SSN_STIP: 'PROOF_OF_SSN_STIP',
	PROOF_OF_EMPLOYMENT_STIP: 'PROOF_OF_EMPLOYMENT_STIP',
	DOWN_PAYMENT_STIP: 'DOWN_PAYMENT_STIP',
	VALID_DRIVERS_LICENSE_STIP: 'VALID_DRIVERS_LICENSE_STIP',
	FIRST_TIME_BUYER_STIP: 'FIRST_TIME_BUYER_STIP',
	FULL_INSURANCE_COVERAGE_REQUIRED_STIP: 'FULL_INSURANCE_COVERAGE_REQUIRED_STIP',
	ITEMIZED_ACCESSORY_LIST_STIP: 'ITEMIZED_ACCESSORY_LIST_STIP',
};

export const FRF_STIP_TO_EKHO_STIP_MAPPING = {
	'out of state applicant contract to be notarized': [
		EKHO_FINANCING_STIPULATIONS_KEYS.NOTARIZED_CONTRACT_STIP,
	],
	'please provide 2 personal references': [
		EKHO_FINANCING_STIPULATIONS_KEYS.PERSONAL_REFERENCES_STIP,
	],
	'this application is max financed': [EKHO_FINANCING_STIPULATIONS_KEYS.MAX_FINANCED_STIP],
	'proof of residence': [EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_RESIDENCE_STIP],
	'proof of income': [EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_INCOME_STIP],
	'please provide additional income consumers debt to income ratio too high': [
		EKHO_FINANCING_STIPULATIONS_KEYS.ADDITIONAL_INCOME_STIP,
	],
	'please provide additional income consumers payment to income ratio too high': [
		EKHO_FINANCING_STIPULATIONS_KEYS.ADDITIONAL_INCOME_STIP,
	],
	'please provide proof of additional income': [
		EKHO_FINANCING_STIPULATIONS_KEYS.ADDITIONAL_INCOME_STIP,
	],
	'please have the applicant call freedom road to verify identity': [
		EKHO_FINANCING_STIPULATIONS_KEYS.CALL_FRF_TO_VERIFY_IDENTITY_STIP,
	],
	'please have the applicant call underwriting to verify identity': [
		EKHO_FINANCING_STIPULATIONS_KEYS.CALL_FRF_TO_VERIFY_IDENTITY_STIP,
	],
	'please provide current work phone number': [
		EKHO_FINANCING_STIPULATIONS_KEYS.PROVIDE_CURRENT_WORK_PHONE_NUMBER_STIP,
	],
	'must have full down payment': [EKHO_FINANCING_STIPULATIONS_KEYS.DOWN_PAYMENT_STIP],
	'first time buyer': [
		EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_INCOME_STIP,
		EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_RESIDENCE_STIP,
		EKHO_FINANCING_STIPULATIONS_KEYS.PERSONAL_REFERENCES_STIP,
		EKHO_FINANCING_STIPULATIONS_KEYS.FIRST_TIME_BUYER_STIP,
	],
	'first time buyer program -  need poi, por and 2 references': [
		EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_INCOME_STIP,
		EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_RESIDENCE_STIP,
		EKHO_FINANCING_STIPULATIONS_KEYS.PERSONAL_REFERENCES_STIP,
		EKHO_FINANCING_STIPULATIONS_KEYS.FIRST_TIME_BUYER_STIP,
	],
	'proof of employment': [EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_EMPLOYMENT_STIP],
	'ftb program need poi por and 2 references': [
		EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_INCOME_STIP,
		EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_RESIDENCE_STIP,
		EKHO_FINANCING_STIPULATIONS_KEYS.PERSONAL_REFERENCES_STIP,
		EKHO_FINANCING_STIPULATIONS_KEYS.FIRST_TIME_BUYER_STIP,
	],
	'must payoff existing freedom road loan': [
		EKHO_FINANCING_STIPULATIONS_KEYS.PAYOFF_OUTSTANDING_LOAN_STIP,
	],
	'must payoff existing performance finance loan': [
		EKHO_FINANCING_STIPULATIONS_KEYS.PAYOFF_OUTSTANDING_LOAN_STIP,
	],
	'please provide a copy of a valid drivers license prior to approval': [
		EKHO_FINANCING_STIPULATIONS_KEYS.VALID_DRIVERS_LICENSE_STIP,
	],
	'please provide a copy of the applicant ssn card': [
		EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_SSN_STIP,
	],
	'full insurance coverage required': [
		EKHO_FINANCING_STIPULATIONS_KEYS.FULL_INSURANCE_COVERAGE_REQUIRED_STIP,
	],
	'itemized accessory list': [EKHO_FINANCING_STIPULATIONS_KEYS.ITEMIZED_ACCESSORY_LIST_STIP],
};

export const IRONHORSE_STIP_TO_EKHO_STIP_MAPPING = {
	'new insurance binder loss payee address see approval ltr': [], // IGNORE THIS STIP, map to empty array
	'new lienholder address for title & ucc see approval ltr': [], // IGNORE THIS STIP, map to empty array
	'bill of sale': [], // IGNORE THIS STIP, map to empty array
	'open hd tied to trade in to be paid off': [
		EKHO_FINANCING_STIPULATIONS_KEYS.PAYOFF_OUTSTANDING_LOAN_STIP,
	],
	'proof of income applicant pay stub with ytd income': [
		EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_INCOME_STIP,
	],
	'proof of income coapplicant pay stub with ytd income': [
		EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_INCOME_STIP,
	],
	'5 references': [EKHO_FINANCING_STIPULATIONS_KEYS.FIVE_PERSONAL_REFERENCES_STIP],
	'2 references': [EKHO_FINANCING_STIPULATIONS_KEYS.PERSONAL_REFERENCES_STIP],
	'drivers license applicant': [EKHO_FINANCING_STIPULATIONS_KEYS.VALID_DRIVERS_LICENSE_STIP],
	'drivers license coapplicant': [EKHO_FINANCING_STIPULATIONS_KEYS.VALID_DRIVERS_LICENSE_STIP],
	'proof of residence address applicant': [
		EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_RESIDENCE_STIP,
	],
	'proof of residence address co applicant': [
		EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_RESIDENCE_STIP,
	],
	'clear credit bureau alert': [], // IGNORE THIS STIP, map to empty array
	'ss card or irs documentation to confirm ssn applicant': [
		EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_SSN_STIP,
	],
	'proof of income prior year ytd paystub or w2 applicant': [
		EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_INCOME_STIP,
	],
	'proof of income prior year ytd paystub or w2 co applicant': [
		EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_INCOME_STIP,
	],
};

export const CREDIT_APP_DISCLAIMER = `By clicking the button below, I agree to have my credit application submitted to Ekho Inc. and its subsidiaries (collectively "Ekho").  I authorize Ekho, its affiliates, and any bank or lender, or other institution (collectively "Creditor") to whom my application is submitted to investigate my credit and employment history, verify my employment and income, obtain credit reports, and to the extent permitted by law, release information about my credit experience now or in the future. I acknowledge and agree that each Creditor may monitor and record telephone calls regarding my account for quality assurance or other similar purposes. Each Creditor may contact me by written, electronic or verbal means, to the extent permitted by law. I expressly agree to being contacted by prerecorded or artificial voice messages, text messages, emails and/or automatic telephone dialing systems at any e-mail address or any telephone number I provide, now or in the future, including a number for a mobile device, regardless of whether I incur charges as a result. NOTE that, if you are accepted for financing and your vehicle is not delivered within 60 days of your original submission, your credit application will be re-submitted to the lender for re-approval and your original financing terms will not be guaranteed.`;

/* FINANCING DEFAULT CONSTS */
export const INITIAL_TERM = 84;
export const INITIAL_DOWN_PAYMENT_SUBTRACTION = 1500;
export const DEFAULT_MIN_LOAN_AMOUNT = 2500;

export const EKHO_FINANCING_APPLICATION_SECTIONS = {
	PREFERRED_TERMS: 'Preferred terms',
	PERSONAL_DETAILS: 'Personal details',
	EMPLOYMENT_INFO: 'Employment information',
	OTHER_SOURCES_OF_INCOME: 'Other sources of income',
	ADDITIONAL_INFO: 'Additional information',
};

export const EKHO_FINANCING_APPLICATION_CATEGORIZATIONS = {
	[EKHO_FINANCING_APPLICATION_SECTIONS.PREFERRED_TERMS]: [
		CREDIT_APP_FIELD_IDS.LOAN_TERM,
		CREDIT_APP_FIELD_IDS.DOWN_PAYMENT_AMT,
	],
	[EKHO_FINANCING_APPLICATION_SECTIONS.PERSONAL_DETAILS]: [
		CREDIT_APP_FIELD_IDS.DOB,
		CREDIT_APP_FIELD_IDS.PHONE_NUMBER,
		CREDIT_APP_FIELD_IDS.SSN,
		CREDIT_APP_FIELD_IDS.MARITAL_STATUS,
		CREDIT_APP_FIELD_IDS.HOME_ADDRESS_SAME_AS_ID_ADDRESS,
		CREDIT_APP_FIELD_IDS.HOUSING_OWNERSHIP,
		CREDIT_APP_FIELD_IDS.HOME_MOVE_IN_DATE,
		CREDIT_APP_FIELD_IDS.MONTHLY_AMT,
		'addressString',
		'addressLineOne',
		'addressLineTwo',
		'city',
		'county',
		'state',
		'zip',
	],
	[EKHO_FINANCING_APPLICATION_SECTIONS.EMPLOYMENT_INFO]: [
		CREDIT_APP_FIELD_IDS.EMPLOYMENT_STATUS,
		CREDIT_APP_FIELD_IDS.MONTHLY_GROSS_INCOME,
		CREDIT_APP_FIELD_IDS.EMPLOYER_NAME,
		CREDIT_APP_FIELD_IDS.EMPLOYER_PHONE_NUMBER,
		CREDIT_APP_FIELD_IDS.OCCUPATION,
		CREDIT_APP_FIELD_IDS.JOB_START_DATE,
		'addressString',
		'addressLineOne',
		'addressLineTwo',
		'city',
		'county',
		'state',
		'zip',
	],
	[EKHO_FINANCING_APPLICATION_SECTIONS.OTHER_SOURCES_OF_INCOME]: ['otherIncomes'],
	[EKHO_FINANCING_APPLICATION_SECTIONS.ADDITIONAL_INFO]: [CREDIT_APP_FIELD_IDS.NOTE_TO_LENDER],
};

export const PAYMENT_TYPES = {
	// BUYER PAYMENTS
	STANDARD_RESERVATION: 'STANDARD_RESERVATION',
	LOAN_DOWNPAYMENT: 'LOAN_DOWNPAYMENT',
	CHECKOUT_FULL_PAYMENT: 'CHECKOUT_FULL_PAYMENT',
	KLARNA_CHECKOUT_FULL_PAYMENT: 'KLARNA_CHECKOUT_FULL_PAYMENT',
	EARLY_REMAINING_BALANCE: 'EARLY_REMAINING_BALANCE',
	LATE_REMAINING_BALANCE: 'LATE_REMAINING_BALANCE',
	LOAN_ADDITIONAL_DOWN: 'LOAN_ADDITIONAL_DOWN',
	// LENDER PAYMENTS
	LENDER_FULL_PAYMENT: 'LENDER_FULL_PAYMENT',
	// NON-EKHO PRECHECKOUT PAYMENTS
	PRECHECKOUT: 'PRECHECKOUT',
	// EKHO COLLECTED PREORDER PAYMENTS
	PREORDER_RESERVATION: 'PREORDER_RESERVATION',
	PREORDER_VIP_RESERVATION: 'PREORDER_VIP_RESERVATION',
};

// Hotjar map
export const OEM_KEY_TO_HOTJAR_SITE_ID = {
	BUYER_PORTAL: {
		janus: 3720403,
		moke: 3720410,
		e2etestoem: 3715982,
	},
	CHECKOUT: {
		stark: 5101827,
	},
};

// Stripe payment status enum
export const PAYMENT_STATUS_ENUM = {
	PROCESSING: 'processing',
	SUCCEEDED: 'succeeded',
	REQUIRES_PAYMENT_METHOD: 'requires_payment_method',
	REQUIRES_ACTION: 'requires_action',
	CANCELED: 'canceled',
	REQUIRES_CONFIRMATION: 'requires_confirmation',
	REQUIRES_CAPTURE: 'requires_capture',
};

export const CANCELATION_AGENT_ENUM = {
	BUYER_CANCELED: 'BUYER_CANCELED',
	EKHO_CANCELED: 'EKHO_CANCELED',
};

export const LENDER_DECISION_OPTIONS = {
	accepted: 'accepted',
	rejected: 'rejected',
	needMoreInfo: 'needMoreInfo',
	counterOffer: 'counterOffer',
};

// The different types of decisions a buyer can make on a finance offer from the lender. This will grow with time.
export const financeOfferBuyerDecisionTypes = {
	accepted: 'accepted',
	declined: 'declined',
};

export const RELOCATION_FLOWS = {
	SELECT_DELIVERY_PREF: 'SELECT_DELIVERY_PREF',
	SEE_FINANCING_DECISIONS: 'SEE_FINANCING_DECISIONS',
	RETRY_INSURANCE_VALIDATION: 'RETRY_INSURANCE_VALIDATION',
	FAILED_ACH_PAYMENT: 'FAILED_ACH_PAYMENT',
	SIGN_RIC: 'SIGN_RIC',
	FINANCING_STIPULATIONS: 'FINANCING_STIPULATIONS',
	SIGN_FINANCING_DOCS: 'SIGN_FINANCING_DOCS',
	ROBOTIC_SIGNING_START_SIGNING: 'ROBOTIC_SIGNING_START_SIGNING',
	ROBOTIC_SIGNING_APPROVED: 'ROBOTIC_SIGNING_APPROVED',
	ROBOTIC_SIGNING_MISSED_SESSION: 'ROBOTIC_SIGNING_MISSED_SESSION',
	ROBOTIC_SIGNING_CANCEL_SIGNING: 'ROBOTIC_SIGNING_CANCEL_SIGNING',
	ROBOTIC_SIGNING_RESCHEDULE_SIGNING: 'ROBOTIC_SIGNING_RESCHEDULE_SIGNING',
	ROBOTIC_SIGNING_REDO_SIGNING: 'ROBOTIC_SIGNING_REDO_SIGNING',
	// Add other relocation flows here...
	// Note: must also add to buyer portal
};

export const FULFILLMENT_STATUS_ENUM = {
	UNFULFILLED: 'UNFULFILLED',
	ON_HOLD: 'ON_HOLD',
	CANCELED: 'CANCELED',
	READY_TO_FULFILL: 'READY_TO_FULFILL',
	READY_TO_DISPATCH: 'READY_TO_DISPATCH',
	FULFILLED: 'FULFILLED',
	IN_TRANSIT_TO_BUYER: 'IN_TRANSIT_TO_BUYER',
	IN_TRANSIT_TO_FULFILLMENT_CENTER: 'IN_TRANSIT_TO_FULFILLMENT_CENTER',
	PICKUP_SCHEDULED: 'PICKUP_SCHEDULED',
	DELIVERY_FULFILLMENT_IN_PROGRESS: 'DELIVERY_FULFILLMENT_IN_PROGRESS',
	RECEIVED_AT_FULFILLMENT_CENTER: 'RECEIVED_AT_FULFILLMENT_CENTER',
};

export const RELOC_MODAL_NAMES = {
	FAILED_ACH_MODAL: 'failedACHPaymentModal',
	SIGN_RIC_MODAL: 'signRICModal',
	SIGN_FINANCING_DOCS_MODAL: 'signFinancingDocsModal',
	SURVEY_MODAL: 'surveyModal',
	FINANCING_STIPULATIONS_MODAL: 'financingStipulationsModal',
	FAILED_KLARNA_PAYMENT_MODAL: 'failedKlarnaPaymentModal',
	RETRY_INSURANCE_VALIDATION_MODAL: 'retryInsuranceValidationModal',
	SEE_FINANCING_DECISIONS_MODAL: 'seeFinancingDecisionsModal',
	FINALIZE_FINANCING_SELECTION_MODAL: 'finalizeFinancingSelectionModal',
	ROBOTIC_SIGNING_START_SIGNING: 'roboticSigningStartSigningModal',
	ROBOTIC_SIGNING_APPROVED: 'roboticSigningApprovedModal',
	ROBOTIC_SIGNING_MISSED_SESSION: 'roboticSigningMissedSessionModal',
	ROBOTIC_SIGNING_CANCEL_SIGNING: 'roboticSigningCancelSigningModal',
	ROBOTIC_SIGNING_RESCHEDULE_SIGNING: 'roboticSigningRescheduleSigningModal',
	ROBOTIC_SIGNING_REDO_SIGNING: 'roboticSigningRedoSigningModal',
};

export const AllModalPageNames = {
	loadingPage: 'loadingPage',
	getStartedPage: 'getStartedPage',
	// beginVerificationPage: 'beginVerificationPage',
	// verificationInProgressPage: 'verificationInProgressPage',
	// verificationSucceededPage: 'verificationSucceededPage',
	// verificationRetryPage: 'verificationRetryPage',
	signOffPage: 'signOffPage',
	somethingWrongPage: 'somethingWrongPage',
	deliverySelectionPage: 'deliverySelectionPage',
	registrationAddressSelectionPage: 'registrationAddressSelectionPage',
	verificationMaxAttemptsPage: 'verificationMaxAttemptsPage',
	selectDeliveryPrefPage: 'selectDeliveryPrefPage',
	simpleAlertModal: 'simpleAlertModal',
	ekhoMustTARAlertModal: 'ekhoMustTARAlertModal',
	orderCancellationModal: 'orderCancellationModal',
	seeFinancingDecisionsModal: 'seeFinancingDecisionsModal',
	retryInsuranceValidationModal: 'retryInsuranceValidationModal',
	failedACHPaymentModal: 'failedACHPaymentModal',
	signRICModal: 'signRICModal',
	surveyModal: 'surveyModal',
	financingStipulationsModal: 'financingStipulationsModal',
	roboticSigningStartSigningModal: 'roboticSigningStartSigningModal',
	roboticSigningApprovedModal: 'roboticSigningApprovedModal',
	roboticSigningMissedSessionModal: 'roboticSigningMissedSessionModal',
	roboticSigningCancelSigningModal: 'roboticSigningCancelSigningModal',
	roboticSigningRescheduleSigningModal: 'roboticSigningRescheduleSigningModal',
	roboticSigningRedoSigningModal: 'roboticSigningRedoSigningModal',
	failedKlarnaPaymentModal: 'failedKlarnaPaymentModal',
	authSessionExpiredModal: 'authSessionExpiredModal',
	confirmDeclineFinancingModal: 'confirmDeclineFinancingModal',
	signFinancingDocsModal: 'signFinancingDocsModal',
};

export const EKHO_SERVICES_PROVIDER_ID = 'svp_ekho';

export const ROBOTIC_SIGNING_STATUS = {
	scheduled: 'scheduled',
	in_session: 'in_session',
	self_review: 'self_review',
	under_review: 'under_review',
	approved: 'approved',
};

export const NO_VIN_NEEDED_VEHICLE_TYPES = [
	INTERNAL_VEHICLE_TYPE_ENUM.E_BIKE,
	INTERNAL_VEHICLE_TYPE_ENUM.BICYCLE,
];
export const NO_ODOMETER_VEHICLE_TYPES = [
	INTERNAL_VEHICLE_TYPE_ENUM.E_BIKE,
	INTERNAL_VEHICLE_TYPE_ENUM.BICYCLE,
	INTERNAL_VEHICLE_TYPE_ENUM.GO_KART, // there may be some go karts that have odometers but we do not sell any right now
];

export const PAYMENT_CHOICES = {
	CHECKOUT_FULL_PAYMENT: 'CHECKOUT_FULL_PAYMENT',
	LOAN_DOWNPAYMENT: 'LOAN_DOWNPAYMENT', // Value when financing is selected (even if zero downpayment)
	STANDARD_RESERVATION: 'STANDARD_RESERVATION',
	PREORDER_RESERVATION: 'PREORDER_RESERVATION',
	PREORDER_VIP_RESERVATION: 'PREORDER_VIP_RESERVATION',
	KLARNA_CHECKOUT_FULL_PAYMENT: 'KLARNA_CHECKOUT_FULL_PAYMENT',
};

export const LINE_ITEM_CATEGORIES = {
	VEHICLES: 'vehicles',
	LOOSE_ACCESSORIES: 'looseAccessories',
};

export const LINE_ITEM_CODES = {
	MSRP: 'MSRP',
	ACCESSORY: 'ACCESSORY',
	SPEC: 'SPEC',
	BOLT_ON_ACCESSORY: 'BOLT_ON_ACCESSORY',
	LOOSE_ACCESSORY: 'LOOSE_ACCESSORY',
	SHIPPING_FEE: 'SHIPPING_FEE',
	PICKUP_FEE: 'PICKUP_FEE',
	VEHICLE_ORDER_FEE: 'VEHICLE_ORDER_FEE',
	VIP_RESERVATION_FEE: 'VIP_RESERVATION_FEE',
	TEMP_TAG_FEE: 'TEMP_TAG_FEE',
	LOOSE_ACCESSORY_TAX: 'LOOSE_ACCESSORY_TAX',
	VEHICLE_SALES_TAX: 'VEHICLE_SALES_TAX',
	REGISTRATION_FEE: 'REGISTRATION_FEE',
	DISCOUNT: 'DISCOUNT',
	FULL_PAYMENT_DISCOUNT: 'FULL_PAYMENT_DISCOUNT',
	KLARNA_DISCOUNT: 'KLARNA_DISCOUNT',
	FINANCING_DOWNPAYMENT: 'FINANCING_DOWNPAYMENT',
	PREV_PAID: 'PREV_PAID',
	STATE_TAX: 'STATE_TAX',
	STATE_FEE: 'STATE_FEE',
	VENDOR_FEE: 'VENDOR_FEE',
};

export const SARDINE_SESSION_KEY = 'sardineSession';
